import api from '../api/api';
const state = () => ({
    user: null
});

const mutations = {
    setUser(state, data) {
        state.user = data;
    }
};
const getters = {
    getUser(state) {
        return state.user;
    }
};

const actions = {
    GET_USER({ commit }, id) {
        if (!id) { return null; }
        return api.users.findOne(id,
            {
                expand: "boosterInfoRelation.gameModel,userAbout,boosterVerify"
            }
        )
            .then(response => {

                commit('setUser', response.data.data);
                return response.data;

            })
            .catch(exception => {
                return exception.response.data
            }
            )
    },
    async GET_ME({ commit }) {
        try {
            const meResponse = await api.users.me()

            commit('setUser', meResponse.data);
            return meResponse.data.data;
        } catch (err) {
            commit('setUser', null)
            return err.response
        }
    }
}

const users = {
    namespaced: true,
    state,
    mutations,
    getters,
    actions,
}

export default users;